import { render, staticRenderFns } from "./DigitalGoldSection.vue?vue&type=template&id=5b420450&scoped=true"
import script from "./DigitalGoldSection.vue?vue&type=script&lang=js"
export * from "./DigitalGoldSection.vue?vue&type=script&lang=js"
import style0 from "./DigitalGoldSection.vue?vue&type=style&index=0&id=5b420450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b420450",
  null
  
)

export default component.exports